import {getLogger} from '@ludwig/utilities'

export const log = getLogger('APP')

const logLevel = process.env.REACT_APP_DEBUG || 'info'

log.setLevel(logLevel)

export default log